module.exports = __webpack_public_path__ + "static/img/wechart.f3bbde41.jpg";